import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { DateRange } from 'react-day-picker'
import { rootInitialState } from 'components/FilterBar/context/reducer'
import { DateFormat } from 'constants/General'
import useFilterFromTo from './useFilterFromTo'

export const useFilterDateValues = () => {
  const formattedStartDate = dayjs(rootInitialState?.from).format(DateFormat.YYYY_MM_DD)
  const formattedEndDate = dayjs(rootInitialState?.to).format(DateFormat.YYYY_MM_DD)

  const initialDateValue = {
    from: new Date(rootInitialState?.from),
    to: new Date(rootInitialState?.to),
  }

  const {
    resetDateRange,
    setFrom,
    setTo,
    setIsTouched,
    from: contextFrom,
    to: contextTo,
  } = useFilterFromTo()

  const [dateValue, setDateValue] = useState<DateRange>(initialDateValue)

  const onDateSelected = (dateVal: DateRange) => {
    setDateValue(dateVal)
    const fromDate = dateVal?.from || null
    const toDate = dateVal?.to || new Date()
    if (fromDate) {
      setFrom(fromDate)
      setTo(toDate)
      setIsTouched(true)
    }
  }

  const safeFromDate = dateValue?.from || rootInitialState.from
  const safeToDate = dateValue?.to || rootInitialState.to

  useEffect(() => {
    const isContextDatesReset =
      contextFrom?.toDateString() === rootInitialState.from?.toDateString() &&
      contextTo?.toDateString() === rootInitialState.to?.toDateString()
    if (isContextDatesReset) {
      setDateValue({
        from: new Date(formattedStartDate),
        to: new Date(formattedEndDate),
      })
    }
  }, [contextFrom, contextTo])

  return {
    initialDateValue,
    safeFromDate,
    safeToDate,
    dateValue,
    formattedStartDate,
    formattedEndDate,
    setDateValue,
    onDateSelected,
    resetDateRange,
  }
}
